import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { HeaderColumnComponent } from '../header-column.component';

@Component({
  selector: 'app-header-column-strain',
  templateUrl: './header-column-strain.component.html',
  styleUrl: './header-column-strain.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class HeaderColumnStrainComponent extends HeaderColumnComponent {}
